import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterLink } from '@angular/router';
import { HomeSearchCtaBannerCard } from '../home-search-cta-banner.interface';

@Component({
    selector: 'app-home-search-cta-banner-card',
    imports: [CommonModule, MatCardModule, MatIconModule, MatTooltipModule, RouterLink, MatCardModule],
    templateUrl: './home-search-cta-banner-card.component.html',
    styleUrls: ['./home-search-cta-banner-card.component.scss'],
})
export class HomeSearchCtaBannerCardComponent {
    @Input() props: HomeSearchCtaBannerCard['props'];
}
